import { render, staticRenderFns } from "./RessifApexBarChart.vue?vue&type=template&id=701ed4f2&"
import script from "./RessifApexBarChart.vue?vue&type=script&lang=ts&"
export * from "./RessifApexBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports